import { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";

import { AuthContext } from "../contexts/auth";
import { useAuth } from '../contexts/auth2';

function PrivateRoute(){

  const { signed } = useAuth();
  if (signed === null) return <div>Loading...</div>; // Evita render precoce

  return signed ? <Outlet /> : <Navigate to="/login" />;
  
};

export default PrivateRoute;